import {createContext, useMemo, useState} from 'react';

interface PostContextType {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
}

export const PostContext = createContext<PostContextType | null>(null);

interface PostContextProviderProps {
  children: React.ReactNode;
}

export const PostContextProvider = ({children}: PostContextProviderProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const value = useMemo(
    () => ({
      isEditing,
      setIsEditing,
    }),
    [isEditing]
  );

  return <PostContext.Provider value={value}>{children}</PostContext.Provider>;
};
